import React, { FC } from 'react';
import clsx from 'clsx';
import styles from './index.module.scss';
import CommonElementProps from '@/types/common-element-props.type';

type Props = CommonElementProps;
const EmptyLayout: FC<Props> = ({ children }) => {
  return (
    <main className={clsx(styles.container, 'vertical-center', 'gridly-background')}>
      <div className={clsx(styles.wrapper, 'vertical-center')}>{children}</div>
    </main>
  );
};

export default EmptyLayout;
